import {
  Collapse,
  Row,
  Col,
  Divider,
  Tag,
  Space,
  message,
} from "antd";
import moment from "moment";
import {
  PlusOutlined,
  DeleteOutlined,
  CopyOutlined,
} from "@ant-design/icons";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  InputItem,
  TextAreaItem,
  InputNumberItem,
  SwitchItem,
  ButtonItem,
  DynamicCardForm,
} from "../../../../Components/Items";
import SelectEmpleadosItem from "../../../../Components/SelectEmpleadosItem";
import TimePickerItem from "../../../../Components/TimePickerItem";
import ModalPlantillaPunto from "../Modales/ModalPlantillaPunto";


import PuntoForm from "./PuntoForm";

const { Panel } = Collapse;

class ProcesoForm extends Component {
  formRef = React.createRef();
  puntosAddRef = null;
  puntoFormRefs = {}; 

  state = {
    diasActivos: [],
    modalPlantillaPunto: false,
    puntosData: [], 
  };

  componentDidMount() {
    const { initialValues } = this.props;
    if (initialValues) {
      this.cargarDatos(initialValues);
    }
  }

  setInitialValues(initialValues) {
    if (!initialValues) return;
    this.cargarDatos(initialValues);
  }

  cargarDatos(initialValues) {
    const { reglasProgramacion = {} } = initialValues;

    let diasActivosUI = [];
    if (reglasProgramacion.diasActivos && reglasProgramacion.diasActivos.length === 7) {
      reglasProgramacion.diasActivos.forEach((activo, index) => {
        if (activo) diasActivosUI.push(String(index));
      });
    }

    const puntosCargados = (initialValues.puntos || []).map((p) => ({
      ...p,
      _key: p._id || Date.now() + Math.random(), 
      derivadoDeNombre: p.derivadoDeNombre || p.derivadoDe?.nombre || "",
      imagen: this.formatearImagenSegura(p.imagen)
    }));

    this.setState({ 
        diasActivos: diasActivosUI,
        puntosData: puntosCargados
    });

    if (this.formRef.current) {
      this.formRef.current.setFieldsValue({
        nombre: initialValues.nombre,
        descripcion: initialValues.descripcion,
        observaciones: initialValues.observaciones,
        prioridad: initialValues.prioridad,
        esPlantilla: initialValues.esPlantilla,
        version: initialValues.version,
        activarCargaImagen: initialValues.activarCargaImagen,
        responsables: initialValues.responsables || [],
        metadatos: initialValues.metadatos || {},
        reglasProgramacion: {
          toleranciaRetardo: reglasProgramacion.toleranciaRetardo,
          requireAprobacion: reglasProgramacion.requireAprobacion,
          requirePresencia: reglasProgramacion.requirePresencia,
          duracionEstimada: reglasProgramacion.duracionEstimada,
          horariosEjecucion: reglasProgramacion.horariosEjecucion || [],
        },
      });
    }

    this.props.onNombreChange?.(initialValues.nombre);
  }

  handleValuesChange(changedValues) {
    if (changedValues.nombre !== undefined) {
      this.props.onNombreChange?.(changedValues.nombre);
    }
    if (!changedValues.responsables) return;
    const changedIdx = changedValues.responsables.findIndex(
      (r) => r && r.esPrincipal === true
    );
    if (changedIdx === -1) return;
    const responsables = this.formRef.current?.getFieldValue("responsables") || [];
    const updated = responsables.map((r, i) => ({
      ...r,
      esPrincipal: i === changedIdx,
    }));
    this.formRef.current?.setFieldsValue({ responsables: updated });
  }

  async getData() {
    let values;
    try {
      values = await this.formRef.current.validateFields();
    } catch {
      message.error("Revisa los campos requeridos del proceso");
      return Promise.reject();
    }

    if (this.state.diasActivos.length === 0) {
      message.error("Debe seleccionar al menos un día activo en las reglas de programación");
      return Promise.reject();
    }
    if (!values.reglasProgramacion?.horariosEjecucion?.length) {
      message.error("Debe agregar al menos un horario de ejecución");
      return Promise.reject();
    }
    const toMin = (t) => { const [h, m] = t.split(":").map(Number); return h * 60 + m; };
    const horarios = values.reglasProgramacion.horariosEjecucion;
    for (let i = 0; i < horarios.length; i++) {
      for (let j = i + 1; j < horarios.length; j++) {
        const a = horarios[i], b = horarios[j];
        if (!a.horaInicio || !a.horaFin || !b.horaInicio || !b.horaFin) continue;
        if (toMin(a.horaInicio) < toMin(b.horaFin) && toMin(b.horaInicio) < toMin(a.horaFin)) {
          message.error(`Los horarios ${a.horaInicio}-${a.horaFin} y ${b.horaInicio}-${b.horaFin} se solapan`);
          return Promise.reject();
        }
      }
    }
    if (!values.responsables?.length) {
      message.error("Debe agregar al menos un responsable");
      return Promise.reject();
    }
    if (this.state.puntosData.length === 0) {
      message.error("Debe agregar al menos un punto al proceso");
      return Promise.reject();
    }

    const diasBooleanos = [false, false, false, false, false, false, false];
    this.state.diasActivos.forEach((diaIdx) => {
      diasBooleanos[Number(diaIdx)] = true;
    });

    const puntoDataPromises = this.state.puntosData.map((punto) => {
        const ref = this.puntoFormRefs[punto._key];
        if (ref && ref.getData) {
            return ref.getData()
                .then((puntoDataForm) => {
                    return { ...puntoDataForm, _id: punto._id }; 
                })
                .catch((err) => {
                    console.error("Error validando el punto:", punto.nombre || punto._key, err);
                    message.error(`Error en el punto: ${punto.nombre || 'Sin nombre'}. Revisa que no falten campos.`);
                    return Promise.reject(err);
                });
        }
        return Promise.resolve(null);
    });

    let puntosConvertidos;
    try {
        puntosConvertidos = await Promise.all(puntoDataPromises);
    } catch (error) {
        
        return Promise.reject();
    }

    puntosConvertidos = puntosConvertidos.filter(p => p !== null);

    return {
      proceso: {
        nombre: values.nombre,
        descripcion: values.descripcion || "",
        observaciones: values.observaciones || "",
        responsables: values.responsables || [],
        activarCargaImagen: values.activarCargaImagen || false,
        prioridad: values.prioridad || 0,
        esPlantilla: values.esPlantilla || false,
        version: values.version || "",
        derivadoDe: this.props.initialValues?.derivadoDe || null,
        metadatos: values.metadatos || {},
        reglasProgramacion: {
          diasActivos: diasBooleanos,
          toleranciaRetardo: values.reglasProgramacion?.toleranciaRetardo || 0,
          requireAprobacion: values.reglasProgramacion?.requireAprobacion || false,
          requirePresencia: values.reglasProgramacion?.requirePresencia || false,
          duracionEstimada: values.reglasProgramacion?.duracionEstimada || 0,
          horariosEjecucion: values.reglasProgramacion?.horariosEjecucion || [],
        },
        puntos: puntosConvertidos,
      },
      puntos: puntosConvertidos,
    };
  }

  toggleDia(dia) {
    this.setState((prev) => {
      const set = new Set(prev.diasActivos);
      if (set.has(dia)) set.delete(dia);
      else set.add(dia);
      return { diasActivos: [...set] };
    });
  }

  formatearImagenSegura(img) {
    if (!img) return []; 
    if (Array.isArray(img)) return img; 
    
    if (typeof img === "string" && img.trim() !== "") {

      let urlLimpia = img.replace(/^(\.\.\/)+/, "").replace(/\\/g, "/"); 
      const nombreArchivo = urlLimpia.split("/").pop();
      const urlFinal = urlLimpia.startsWith("http") ? urlLimpia : `/${urlLimpia}`;

      return [
        {
          uid: `file-${Date.now()}-${Math.random()}`,
          name: nombreArchivo || "imagen_plantilla.png",
          status: "done",
          url: urlFinal, 
        },
      ];
    }
    return [];
  }

  agregarPunto(plantilla = null) {
    const key = Date.now() + Math.random();
    const nuevoPunto = plantilla 
      ? {
          ...plantilla,
          _key: key,
          derivadoDe: plantilla._id,
          derivadoDeNombre: plantilla.nombre,
          esPlantilla: false, 
          version: "",
          imagen: this.formatearImagenSegura(plantilla.imagen)
        }
      : { 
          _key: key, 
          nombre: `Punto ${this.state.puntosData.length + 1}`,
          procedimiento: { pasos: [] },
          criterios: [],  
          imagen: [] 
        };

    this.setState((prev) => ({
      puntosData: [...prev.puntosData, nuevoPunto],
      modalPlantillaPunto: false,
    }));
  }

  eliminarPunto(key) {
    this.setState((prev) => {
      const puntosData = prev.puntosData.filter((p) => p._key !== key);
      delete this.puntoFormRefs[key]; // Limpiamos la ref
      return { puntosData };
    });
  }

  abrirModalPlantillasPunto() {
    this.setState({ modalPlantillaPunto: true });
  }

 onPuntoModalSuccess(data) {
    const normalizado = {
      ...data,
      derivadoDe: data._id,
      derivadoDeNombre: data.nombre,
      imagen: this.formatearImagenSegura(data.imagen), 
      procedimiento: data.procedimiento, 
    };
    this.agregarPunto(normalizado);
  }

  render() {
    const { diasActivos, modalPlantillaPunto, puntosData } = this.state;
    const { disabled, empresaId, headersToken, initialValues, camposCalidad } = this.props;

    const cc = camposCalidad?.proceso ?? {};
    const showToleranciaRetardo = cc.toleranciaRetardo !== false;
    const showRequireAprobacion = cc.requireAprobacion !== false;
    const showRequirePresencia  = cc.requirePresencia  !== false;
    const showDuracionEstimada  = cc.duracionEstimada  !== false;
    const showMetadatos         = cc.metadatos         !== false;

    const DIAS = [
      { label: "Dom", value: "0" },
      { label: "Lun", value: "1" },
      { label: "Mar", value: "2" },
      { label: "Mié", value: "3" },
      { label: "Jue", value: "4" },
      { label: "Vie", value: "5" },
      { label: "Sáb", value: "6" },
    ];

    const cardStyle = {
      border: "1px solid #ebedf0",
      borderRadius: "8px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
      backgroundColor: "#ffffff",
      padding: "16px",
      width: "100%",
    };

    return (
      <>
        <Form ref={this.formRef} onValuesChange={this.handleValuesChange.bind(this)}>
          <Row gutter={8}>
            <Col span={12}>
              {/* --- INFORMACIÓN DEL PROCESO --- */}
              <DynamicCardForm 
                title={
                  <span>
                    Información del Proceso
                    {initialValues?.derivadoDe && (
                      <Tag color="blue" style={{ marginLeft: 10 }}>
                        Derivado de: {initialValues.derivadoDeNombre || "Plantilla"}
                      </Tag>
                    )}
                  </span>
                } 
                style={cardStyle}
              >
                <Row gutter={16}>
                  <Col span={12}>
                    <FormItem label="Nombre" name="nombre" required labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                      <InputItem placeholder="Nombre del proceso" disabled={disabled} />
                    </FormItem>
                  </Col>
                  <Col span={6}>
                    <FormItem label="Prioridad" name="prioridad" required labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                      <InputNumberItem min={0} max={5} placeholder="0-5" style={{ width: "100%" }} disabled={disabled} />
                    </FormItem>
                  </Col>
                  <Col span={24}>
                    <FormItem label="Descripción" name="descripcion" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                      <TextAreaItem rows={2} disabled={disabled} />
                    </FormItem>
                  </Col>
                  <Col span={24}>
                    <FormItem label="Observaciones" name="observaciones" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                      <TextAreaItem rows={2} disabled={disabled} />
                    </FormItem>
                  </Col>
                </Row>
              </DynamicCardForm>

              <DynamicCardForm title="Referencias Multimedia" style={cardStyle}>
                <FormItem label="Activar carga de imágenes en checklist" name="activarCargaImagen" valuePropName="checked">
                  <SwitchItem disabled={disabled} />
                </FormItem>
              </DynamicCardForm>

              {!initialValues?.derivadoDe && (
              <DynamicCardForm title="Control de Versiones" style={cardStyle}>
                <Row gutter={16}>
                  <Col span={12}>
                    <FormItem label="Es Plantilla" name="esPlantilla" valuePropName="checked">
                      <SwitchItem disabled={disabled} />
                    </FormItem>
                  </Col>
                  <Col span={12}>
                    <FormItem noStyle shouldUpdate={(prev, curr) => prev.esPlantilla !== curr.esPlantilla}>
                      {({ getFieldValue }) =>
                        getFieldValue("esPlantilla") ? (
                          <FormItem label="Versión" name="version" rules={[{ required: true, message: "Ingresa la versión de la plantilla" }]} labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                            <InputItem placeholder="Ej. 1.0" disabled={disabled} />
                          </FormItem>
                        ) : null
                      }
                    </FormItem>
                  </Col>
                </Row>
              </DynamicCardForm>
              )}

              <DynamicCardForm title="Responsables" style={cardStyle}>
                <Form.List name="responsables">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, fieldKey, ...restField }) => (
                        <Row gutter={2} key={key} style={{ marginBottom: 8 }}>
                          <Col span={disabled ? 10 : 9}>
                            <FormItem {...restField} name={[name, "empleadoId"]} style={{ marginBottom: 0 }}>
                              <SelectEmpleadosItem empresaId={empresaId} headersToken={headersToken} placeholder="Empleado" disabled={disabled} />
                            </FormItem>
                          </Col>
                          <Col span={disabled ? 8 : 6}>
                            <FormItem {...restField} name={[name, "rol"]} style={{ marginBottom: 0 }}>
                              <InputItem placeholder="Rol" disabled={disabled} />
                            </FormItem>
                          </Col>
                          <Col span={6}>
                            <FormItem {...restField} label="Prin." name={[name, "esPrincipal"]} valuePropName="checked" style={{ marginBottom: 0 }}>
                              <SwitchItem disabled={disabled} />
                            </FormItem>
                          </Col>
                          {!disabled && (
                            <Col span={2} style={{ paddingTop: "4px" }}>
                              <ButtonItem danger size="small" icon={<DeleteOutlined />} onClick={() => remove(name)} />
                            </Col>
                          )}
                        </Row>
                      ))}
                      {!disabled && (
                        <ButtonItem icon={<PlusOutlined />} size="small" onClick={() => add({ esPrincipal: false })}>
                          Agregar Responsable
                        </ButtonItem>
                      )}
                    </>
                  )}
                </Form.List>
              </DynamicCardForm>
            </Col>

            <Col span={12}>
              <DynamicCardForm title="Reglas de Programación" style={cardStyle}>
                <Row gutter={16}>
                  <Col span={24}>
                    <FormItem label="Días activos en la semana">
                      <Space wrap>
                        {DIAS.map((d) => (
                          <Tag
                            key={d.value}
                            color={diasActivos.includes(d.value) ? "blue" : "default"}
                            style={{ cursor: "pointer", userSelect: "none" }}
                            onClick={() => !disabled && this.toggleDia(d.value)}
                          >
                            {d.label}
                          </Tag>
                        ))}
                      </Space>
                    </FormItem>
                  </Col>
                  {showToleranciaRetardo && (
                    <Col span={12}>
                      <FormItem label="Tolerancia retardo (min)" name={["reglasProgramacion", "toleranciaRetardo"]} labelCol={{ span: 18 }} wrapperCol={{ span: 6 }}>
                        <InputNumberItem min={0} placeholder="0" style={{ width: "100%" }} disabled={disabled} />
                      </FormItem>
                    </Col>
                  )}
                  {showDuracionEstimada && (
                    <Col span={12}>
                      <FormItem label="Duración estimada (min)" name={["reglasProgramacion", "duracionEstimada"]} labelCol={{ span: 18 }} wrapperCol={{ span: 6 }}>
                        <InputNumberItem min={0} placeholder="0" style={{ width: "100%" }} disabled={disabled} />
                      </FormItem>
                    </Col>
                  )}
                  {showRequireAprobacion && (
                    <Col span={12}>
                      <FormItem label="Requiere aprobación" name={["reglasProgramacion", "requireAprobacion"]} valuePropName="checked" labelCol={{ span: 18 }} wrapperCol={{ span: 6 }}>
                        <SwitchItem disabled={disabled} />
                      </FormItem>
                    </Col>
                  )}
                  {showRequirePresencia && (
                    <Col span={12}>
                      <FormItem label="Requiere presencia física" name={["reglasProgramacion", "requirePresencia"]} valuePropName="checked" labelCol={{ span: 18 }} wrapperCol={{ span: 6 }}>
                        <SwitchItem disabled={disabled} />
                      </FormItem>
                    </Col>
                  )}
                  <Col span={24}>
                    <Divider orientation="left" style={{ fontSize: 12 }}>Horarios Específicos</Divider>
                    <Form.List name={["reglasProgramacion", "horariosEjecucion"]}>
                      {(fields, { add, remove }) => (
                        <>
                          {fields.map(({ key, name, fieldKey, ...restField }) => (
                            <Row gutter={8} key={key} style={{ marginBottom: 8 }}>
                              <Col span={6}>
                                <FormItem {...restField} name={[name, "horaInicio"]} style={{ marginBottom: 0 }} getValueProps={(v) => ({ value: v ? moment(v, "HH:mm") : null })} normalize={(v) => (v ? v.format("HH:mm") : null)}>
                                  <TimePickerItem format="HH:mm" placeholder="Inicio" style={{ width: "100%" }} disabled={disabled} />
                                </FormItem>
                              </Col>
                              <Col span={6}>
                                <FormItem {...restField} name={[name, "horaFin"]} style={{ marginBottom: 0 }} getValueProps={(v) => ({ value: v ? moment(v, "HH:mm") : null })} normalize={(v) => (v ? v.format("HH:mm") : null)}>
                                  <TimePickerItem format="HH:mm" placeholder="Fin" style={{ width: "100%" }} disabled={disabled} />
                                </FormItem>
                              </Col>
                              <Col span={disabled ? 12 : 9}>
                                <FormItem {...restField} name={[name, "descripcion"]} style={{ marginBottom: 0 }}>
                                  <InputItem placeholder="Descripción" disabled={disabled} />
                                </FormItem>
                              </Col>
                              {!disabled && (
                                <Col span={3}>
                                  <ButtonItem danger size="small" icon={<DeleteOutlined />} onClick={() => remove(name)} />
                                </Col>
                              )}
                            </Row>
                          ))}
                          {!disabled && (
                            <ButtonItem size="small" icon={<PlusOutlined />} onClick={() => add()}>Agregar Horario</ButtonItem>
                          )}
                        </>
                      )}
                    </Form.List>
                  </Col>
                </Row>
              </DynamicCardForm>

              {showMetadatos && (
                <DynamicCardForm title="Datos Extras" style={cardStyle}>
                  <Row gutter={8}>
                    <Col span={24}>
                      <FormItem label="Riesgo" name={["metadatos", "riesgo"]} labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                        <InputItem placeholder="Nivel de riesgo" disabled={disabled} />
                      </FormItem>
                    </Col>
                  </Row>
                  <Divider orientation="left" style={{ fontSize: 12, margin: "4px 0 8px 0" }}>Tipo de actividad</Divider>
                  <Form.List name={["metadatos", "tipoActividad"]}>
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map(({ key, name }) => (
                          <Row gutter={8} key={key} style={{ marginBottom: 6 }}>
                            <Col span={disabled ? 24 : 22}>
                              <FormItem name={name} noStyle><InputItem placeholder="Ej. inspección…" disabled={disabled} /></FormItem>
                            </Col>
                            {!disabled && <Col span={2}><ButtonItem danger size="small" icon={<DeleteOutlined />} onClick={() => remove(name)} /></Col>}
                          </Row>
                        ))}
                        {!disabled && <ButtonItem size="small" icon={<PlusOutlined />} onClick={() => add()} style={{ marginBottom: 12 }}>Agregar tipo</ButtonItem>}
                      </>
                    )}
                  </Form.List>
                  <Divider orientation="left" style={{ fontSize: 12, margin: "4px 0 8px 0" }}>Etiquetas</Divider>
                  <Form.List name={["metadatos", "etiquetas"]}>
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map(({ key, name }) => (
                          <Row gutter={8} key={key} style={{ marginBottom: 6 }}>
                            <Col span={disabled ? 24 : 22}>
                              <FormItem name={name} noStyle><InputItem placeholder="Etiqueta" disabled={disabled} /></FormItem>
                            </Col>
                            {!disabled && <Col span={2}><ButtonItem danger size="small" icon={<DeleteOutlined />} onClick={() => remove(name)} /></Col>}
                          </Row>
                        ))}
                        {!disabled && <ButtonItem size="small" icon={<PlusOutlined />} onClick={() => add()}>Agregar etiqueta</ButtonItem>}
                      </>
                    )}
                  </Form.List>
                </DynamicCardForm>
              )}
            </Col>
          </Row>

          <Row gutter={24} style={{ marginTop: "24px" }}>
            <Col span={24}>
              <DynamicCardForm title="Puntos del Proceso" style={cardStyle}>
                
                {puntosData.length === 0 && (
                  <p style={{ color: "#999", textAlign: "center", margin: "12px 0" }}>
                    No hay puntos agregados.
                  </p>
                )}

                {puntosData.length > 0 && (
                  <Collapse accordion style={{ marginBottom: 12 }}>
                    {puntosData.map((punto, index) => (
                      <Panel
                        key={punto._key}
                        forceRender ={true}
                        header={
                          <span>
                            <strong>{punto.nombre ? `${index + 1}. ${punto.nombre}` : `Punto ${index + 1}`}</strong>
                            {punto.derivadoDe && (
                              <Tag color="cyan" style={{ marginLeft: 8 }}>
                                Derivado de: {punto.derivadoDeNombre || "Plantilla"}
                              </Tag>
                            )}
                          </span>
                        }
                        extra={
                          !disabled && (
                            <ButtonItem
                              danger
                              size="small"
                              icon={<DeleteOutlined />}
                              onClick={(e) => { e.stopPropagation(); this.eliminarPunto(punto._key); }}
                            />
                          )
                        }
                      >
                        <PuntoForm
                            ref={(ref) => {
                                if (ref) this.puntoFormRefs[punto._key] = ref;
                            }}
                            initialValues={punto}
                            disabled={disabled}
                            camposCalidad={camposCalidad}
                        />
                      </Panel>
                    ))}
                  </Collapse>
                )}

                <Space>
                  <ButtonItem icon={<PlusOutlined />} onClick={() => this.agregarPunto()} disabled={disabled}>
                    Agregar Punto
                  </ButtonItem>
                  <ButtonItem icon={<CopyOutlined />} onClick={() => this.abrirModalPlantillasPunto()} disabled={disabled}>
                    Usar Plantilla de Punto
                  </ButtonItem>
                </Space>

              </DynamicCardForm>
            </Col>
          </Row>
        </Form>

        <ModalPlantillaPunto
          visible={modalPlantillaPunto}
          onCancel={() => this.setState({ modalPlantillaPunto: false })}
          onSuccess={this.onPuntoModalSuccess.bind(this)}       
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  camposCalidad: state.empresa.camposCalidad,
});

export default connect(mapStateToProps, null, null, { forwardRef: true })(ProcesoForm);